/**
 * ONE_TWO_THREE -> One Two Three
 */
export const pascalCase = (s: string) => {
  if (!s) {
    return s;
  }
  return s.replace(/_/g, ' ')
    .replace(/(\w)(\w*)/g, function (_g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
}

const PROVIDER_LABELS: Record<string, string> = { stripe: "Stripe", shopify: "Shopify", paypal: "PayPal", adyen: "Adyen", checkout_champ: "CheckoutChamp", crm_connector: "CRM Connector" };

/**
 * paypal -> PayPal; an unknown pp_type falls back to pascalCase
 */
export const providerLabel = (ppType: string) => PROVIDER_LABELS[ppType] ?? pascalCase(ppType);

/**
 * ONE_TWO_THREE -> One two three
 */
export const ucFirstWord = (s: string) => {
  if (!s) {
    return s;
  }

  const words = s.replace(/_/g, ' ').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export const adjustPpReason = (reason: string) => {
  if (reason === 'MERCHANDISE_OR_SERVICE_NOT_RECEIVED') {
    return 'Item not received';
  }
  if (reason === 'MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED') {
    return 'Not as described';
  }
  return ucFirstWord(reason);
}
